import Cookies from 'js-cookie';
const getVisitorIdFromTealium = () => {
    var _a, _b;
    const visitorIdPropertyName = 'tealium_visitor_id';
    return (_b = (_a = window.utag) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b[visitorIdPropertyName];
};
const getVisitorIdFromCookie = () => {
    const cookieName = 'utag_main_v_id';
    const cookieValue = Cookies.get(cookieName);
    return cookieValue ? cookieValue : undefined;
};
const generateRandomVisitorId = () => `visitor-${Date.now()}-${Math.ceil(Math.random() * 10)}`;
export const getVisitorId = () => getVisitorIdFromTealium() || getVisitorIdFromCookie() || generateRandomVisitorId();
//# sourceMappingURL=visitorId.js.map